import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = {
  style: {"min-width":"98px"},
  type: "button",
  class: "btn btn-sm btn-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end",
  name: "trigger menu"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Actions ")
const _hoisted_6 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_7 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-w-green fw-bold fs-7 w-125px py-4",
  "data-kt-menu": "true"
}
const _hoisted_8 = { class: "menu-item px-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "menu-item px-3" }
const _hoisted_12 = { class: "menu-item px-3" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  "data-bs-toggle": "modal",
  "data-bs-target": "#create",
  class: "btn btn-success me-4",
  name: "create type"
}, " Create ", -1)
const _hoisted_15 = {
  ref: "modalRef",
  class: "modal fade",
  id: "create",
  tabindex: "-1",
  "aria-labelledby": "create",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header fs-3" }, "Create New Type", -1)
const _hoisted_19 = { class: "modal-body px-12" }
const _hoisted_20 = ["onSubmit"]
const _hoisted_21 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CardTable = _resolveComponent("CardTable")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CardTable, {
      ref: "tableRef",
      name: "Car Type",
      header: $setup.tableHeader,
      endpoint: "car-type",
      breadcrumbs: $setup.breadcrumbs,
      currentIndex: $setup.currentIndex,
      onChangeIndex: _cache[0] || (_cache[0] = (index) => ($setup.currentIndex = index)),
      "is-delete": false
    }, {
      "cell-no": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.no), 1)
      ]),
      "cell-name": _withCtx(({ row, index }) => [
        ($setup.currentIndex !== index)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(row.name), 1))
          : _createCommentVNode("", true),
        ($setup.currentIndex === index)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "like-el-input w-150px",
                "onUpdate:modelValue": ($event: any) => ((row.name) = $event)
              }, null, 8, _hoisted_3), [
                [_vModelText, row.name]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      "cell-actions": _withCtx(({ row, index }) => [
        _createElementVNode("button", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            ($setup.currentIndex !== index)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: ($event: any) => ($setup.currentIndex = index),
                  class: "menu-link px-3"
                }, "Edit", 8, _hoisted_9))
              : _createCommentVNode("", true),
            ($setup.currentIndex === index)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: ($event: any) => (_ctx.editItem(row, index)),
                  class: "menu-link px-3"
                }, "Save", 8, _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              onClick: ($event: any) => (null),
              class: "menu-link px-3"
            }, "Hide")
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.deleteItem(_ctx.childRef.tableData, row.id, 'car-type')),
              class: "menu-link px-3"
            }, "Delete", 8, _hoisted_13)
          ])
        ])
      ]),
      create: _withCtx(() => [
        _hoisted_14
      ]),
      _: 1
    }, 8, ["header", "breadcrumbs", "currentIndex"]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
            }, [
              _createVNode(_component_el_input, {
                type: "text",
                class: "mb-3",
                placeholder: "Type",
                modelValue: $setup.inputRef.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputRef.name) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.create())),
                  class: "btn btn-primary"
                }, "Confirm")
              ])
            ], 40, _hoisted_20)
          ])
        ])
      ])
    ], 512)
  ], 64))
}